import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TopnavInfoService } from 'src/app/navigation/menuInterfaces/topnav-info.service';

@Injectable({
  providedIn: 'root'
})
export class LoginResolverService implements Resolve<any> {
  constructor(private router: Router, private infoService: TopnavInfoService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Observable<never> {
    console.log('Route Data Cleared', route.paramMap);

    this.infoService.clearRouteData();

    return of({ Cleared: true });
  }
}
